export default "__VITE_ASSET__7$$T_uDE__"